import React, { Component, Fragment } from "react";
import IdleTimer from "react-idle-timer";
import { Redirect, Route, Switch } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import MyPlans from "../../components/MyPlan/MyPlan";
import Support from "../../components/Support/Support";
import Modal from "../../components/UI/Modal/Modal";
import BalanceBilling from "../BalanceBilling/BalanceBilling";
import MyBills from "../BalanceBilling/MyBills/MyBills";
import FindProviderContainer from "../FindProvider/FindProvider";
import MyFavorites from "../FindProvider/Search/MyFavorites/MyFavorites";
import Home from "../Home/Home";
import IdCard from "../IdCard/IdCard";
import Prescriptions from "../Prescriptions/Prescriptions";
import ProcedureShopper from "../ProcedureShopper/ProcedureShopper";
import Telemedicine from "../Telemedicine/Telemedicine";
import { withTranslation } from "react-i18next";
import MessageAlert from "../../components/UI/MessageAlert/MessageAlert";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface IStateFromProps {
  t: any;
}
class RoutePath extends Component<IStateFromProps> {
  state = {
    timeout: 86400000,
    error: false,
  };
  componentDidMount() {
    // Removing Themes for Trust Mark
    // if (localStorage.getItem("clientName")?.toLowerCase().match(/rust/g))
    //   document.body.id = "trustMark";
    this.setState({
      timeout: Number(localStorage.getItem("idletimeout")) * 1000,
    });
    // this.setState({
    //   timeout: 3000,
    // });
    console.log("accessToken", localStorage.getItem("token"));
    console.log("TimeOut =", this.state.timeout);
  }
  errorAlertHandler = () => {
    this.setState({ error: false });
    window.location.replace("/");
    localStorage.clear();
    sessionStorage.clear();
  };

  onIdle = () => {
    this.setState({ error: true });
    console.log("Session time out", Date().toLocaleString());
  };
  render() {
    const modalChildStyle = {};
    /*error message display*/
    let errorMessagePopup: any;
    if (this.state.error) {
      console.log("this.state.error", this.state.error);
      errorMessagePopup = (
        <Modal
          show={this.state.error}
          childComp={
            <MessageAlert
              modalClosed={this.errorAlertHandler}
              error="Session Time Out"
            />
          }
          style={modalChildStyle}
        />
      );
    }

    const routes = (
      <Fragment>
        <ToastContainer />
        {errorMessagePopup}
        <Switch>
          <Route path="/find-provider" component={FindProviderContainer} />
          <Route path="/procedure-shopper" component={ProcedureShopper} />
          <Route path="/balance-billing-newupload" component={BalanceBilling} />
          <Route path="/balance-billing-mybills" component={MyBills} />
          <Route path="/balance-billing" component={BalanceBilling} />
          <Route path="/telemedicine" component={Telemedicine} />
          <Route path="/prescriptions" component={Prescriptions} />
          <Route path="/support" component={Support} />
          <Route path="/myplans" component={MyPlans} />
          <Route path="/idcard" component={IdCard} />
          <Route
            path="/my-favorites"
            component={() => <MyFavorites mapDisplay={true} />}
          />
          {/* <Route
            path="/health-comp"
            component={() => {
              window.location.href =
                "https://ampsispace.b2clogin.com/ampsispace.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_DREXI_SAML_SIGNIN&client_id=75d906ea-0a1a-4c2f-b324-ae81485c8bcd&nonce=defaultNonce&redirect_uri=http%3A%2F%2Flocalhost%3A3000&scope=openid&response_type=id_token&prompt=login&response_mode=query";
              return null;
            }}
          /> */}
          <Route path="/home" component={Home} />
          <Route path="/" exact component={Home} />
          <Redirect to="/" />
        </Switch>
        <IdleTimer
          timeout={this.state.timeout}
          onIdle={this.onIdle}
        ></IdleTimer>
      </Fragment>
    );

    return <Layout>{routes}</Layout>;
  }
}
export default withTranslation()(RoutePath);
